const formatters = new Map();

const getFormatter = (currency, locale) => {
  const key = `${currency}|${locale}`;
  let f = formatters.get(key);
  if (!f) {
    f = new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 2 });
    formatters.set(key, f);
  }
  return f;
};

export const formatMoney = (paise, currency = "INR", locale = "en-IN") => {
  const amount = (Number(paise) || 0) / 100;
  try {
    return getFormatter(currency, locale).format(amount);
  } catch {
    return `${currency} ${amount.toLocaleString(locale)}`;
  }
};

export const paiseToRupees = (paise) => (Number(paise) || 0) / 100;
export const rupeesToPaise = (rupees) => Math.round((Number(rupees) || 0) * 100);

export const inr = (paise) => formatMoney(paise, "INR", "en-IN");
